module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-core");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(4);

var _wonderBlocksCore = __webpack_require__(1);

var _wonderBlocksLayout = __webpack_require__(19);

var _wonderBlocksSpacing = __webpack_require__(3);

var _wonderBlocksSpacing2 = _interopRequireDefault(_wonderBlocksSpacing);

var _wonderBlocksTypography = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component is used to provide the content that is to be rendered in the
 * tooltip bubble.
 */
var TooltipContent = function (_React$Component) {
    _inherits(TooltipContent, _React$Component);

    function TooltipContent() {
        _classCallCheck(this, TooltipContent);

        return _possibleConstructorReturn(this, (TooltipContent.__proto__ || Object.getPrototypeOf(TooltipContent)).apply(this, arguments));
    }

    _createClass(TooltipContent, [{
        key: "_renderTitle",
        value: function _renderTitle() {
            var title = this.props.title;

            if (title) {
                if (typeof title === "string") {
                    return React.createElement(
                        _wonderBlocksTypography.HeadingSmall,
                        null,
                        title
                    );
                } else {
                    return title;
                }
            }
            return null;
        }
    }, {
        key: "_renderChildren",
        value: function _renderChildren() {
            var children = this.props.children;

            if (typeof children === "string") {
                return React.createElement(
                    _wonderBlocksTypography.LabelMedium,
                    null,
                    children
                );
            } else {
                return children;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var title = this._renderTitle();
            var children = this._renderChildren();
            var containerStyle = title ? styles.withTitle : styles.withoutTitle;
            return React.createElement(
                _wonderBlocksCore.View,
                { style: containerStyle },
                title,
                title && children && React.createElement(_wonderBlocksLayout.Strut, { size: _wonderBlocksSpacing2.default.xxxSmall }),
                children
            );
        }
    }]);

    return TooltipContent;
}(React.Component);

exports.default = TooltipContent;


var styles = _aphrodite.StyleSheet.create({
    withoutTitle: {
        margin: "10px " + _wonderBlocksSpacing2.default.medium + "px"
    },

    withTitle: {
        margin: _wonderBlocksSpacing2.default.medium
    }
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-spacing");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("aphrodite");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-color");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _aphrodite = __webpack_require__(4);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _wonderBlocksColor = __webpack_require__(6);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _wonderBlocksCore = __webpack_require__(1);

var _wonderBlocksSpacing = __webpack_require__(3);

var _wonderBlocksSpacing2 = _interopRequireDefault(_wonderBlocksSpacing);

var _tooltipContent = __webpack_require__(2);

var _tooltipContent2 = _interopRequireDefault(_tooltipContent);

var _tooltipTail = __webpack_require__(17);

var _tooltipTail2 = _interopRequireDefault(_tooltipTail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipBubble = function (_React$Component) {
    _inherits(TooltipBubble, _React$Component);

    function TooltipBubble() {
        _classCallCheck(this, TooltipBubble);

        return _possibleConstructorReturn(this, (TooltipBubble.__proto__ || Object.getPrototypeOf(TooltipBubble)).apply(this, arguments));
    }

    _createClass(TooltipBubble, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                id = _props.id,
                children = _props.children,
                updateBubbleRef = _props.updateBubbleRef,
                placement = _props.placement,
                outOfBoundaries = _props.outOfBoundaries,
                style = _props.style,
                updateTailRef = _props.updateTailRef,
                tailOffset = _props.tailOffset;


            return React.createElement(
                _wonderBlocksCore.View,
                {
                    id: id,
                    role: "tooltip",
                    "data-placement": placement,
                    ref: updateBubbleRef,
                    style: [outOfBoundaries && styles.hide, styles.bubble, styles["content-" + placement], style]
                },
                React.createElement(
                    _wonderBlocksCore.View,
                    { style: styles.content },
                    children
                ),
                React.createElement(_tooltipTail2.default, {
                    updateRef: updateTailRef,
                    placement: placement,
                    offset: tailOffset
                })
            );
        }
    }]);

    return TooltipBubble;
}(React.Component);

exports.default = TooltipBubble;


var styles = _aphrodite.StyleSheet.create({
    bubble: {
        pointerEvents: "none",
        position: "absolute"
    },

    /**
     * The hide style ensures that the bounds of the bubble stay unchanged.
     * This is because popper.js calculates the bubble position based off its
     * bounds and if we stopped rendering it entirely, it wouldn't know where to
     * place it when it reappeared.
     */
    hide: {
        pointerEvents: "none",
        opacity: 0,
        backgroundColor: "transparent",
        color: "transparent"
    },

    /**
     * Ensure the content and tail are properly arranged.
     */
    "content-top": {
        flexDirection: "column"
    },
    "content-right": {
        flexDirection: "row-reverse"
    },
    "content-bottom": {
        flexDirection: "column-reverse"
    },
    "content-left": {
        flexDirection: "row"
    },

    content: {
        maxWidth: 472,
        borderRadius: _wonderBlocksSpacing2.default.xxxSmall,
        border: "solid 1px " + _wonderBlocksColor2.default.offBlack16,
        backgroundColor: _wonderBlocksColor2.default.white,
        boxShadow: "0 " + _wonderBlocksSpacing2.default.xSmall + "px " + _wonderBlocksSpacing2.default.xSmall + "px 0 " + _wonderBlocksColor2.default.offBlack8,
        justifyContent: "center"
    }
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactPopper = __webpack_require__(20);

var _tooltipBubble = __webpack_require__(7);

var _tooltipBubble2 = _interopRequireDefault(_tooltipBubble);

var _visibilityModifier = __webpack_require__(16);

var _visibilityModifier2 = _interopRequireDefault(_visibilityModifier);

var _refTracker = __webpack_require__(13);

var _refTracker2 = _interopRequireDefault(_refTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * This component is a light wrapper for react-popper, allowing us to position
 * and control the tooltip bubble location and visibility as we need.
 */


var TooltipPopper = function (_React$Component) {
    _inherits(TooltipPopper, _React$Component);

    function TooltipPopper() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TooltipPopper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipPopper.__proto__ || Object.getPrototypeOf(TooltipPopper)).call.apply(_ref, [this].concat(args))), _this), _this._bubbleRefTracker = new _refTracker2.default(), _this._tailRefTracker = new _refTracker2.default(), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TooltipPopper, [{
        key: "_renderPositionedContent",
        value: function _renderPositionedContent(popperProps) {
            var children = this.props.children;

            // We'll hide some complexity from the children here and ensure
            // that our placement always has a value.

            var placement = popperProps.placement || this.props.placement;

            // Just in case the callbacks have changed, let's update our reference
            // trackers.
            this._bubbleRefTracker.setCallback(popperProps.ref);
            this._tailRefTracker.setCallback(popperProps.arrowProps.ref);

            // Here we translate from the react-popper's PropperChildrenProps
            // to our own TooltipBubbleProps.
            var bubbleProps = {
                placement: placement,
                style: popperProps.style,
                updateBubbleRef: this._bubbleRefTracker.updateRef,
                tailOffset: {
                    top: popperProps.arrowProps.style.top,
                    left: popperProps.arrowProps.style.left
                },
                updateTailRef: this._tailRefTracker.updateRef,
                outOfBoundaries: popperProps.outOfBoundaries
            };
            return children(bubbleProps);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                anchorElement = _props.anchorElement,
                placement = _props.placement;

            return React.createElement(
                _reactPopper.Popper,
                {
                    referenceElement: anchorElement,
                    placement: placement,
                    modifiers: {
                        wbVisibility: _visibilityModifier2.default,
                        preventOverflow: { boundariesElement: "viewport" }
                    }
                },
                function (props) {
                    return _this2._renderPositionedContent(props);
                }
            );
        }
    }]);

    return TooltipPopper;
}(React.Component);

exports.default = TooltipPopper;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * The attribute used to identify a tooltip portal.
 */
var TooltipPortalAttributeName = exports.TooltipPortalAttributeName = "data-tooltip-portal";
var TooltipAppearanceDelay = exports.TooltipAppearanceDelay = 100;
var TooltipDisappearanceDelay = exports.TooltipDisappearanceDelay = 75;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(5);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _wonderBlocksModal = __webpack_require__(21);

var _constants = __webpack_require__(9);

var _tooltipPopper = __webpack_require__(8);

var _tooltipPopper2 = _interopRequireDefault(_tooltipPopper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A private component used by Tooltip, that behaves similarly to a React
 * "portal". It renders its children in a new node in `document.body` or
 * the parent modal launcher portal, rather than in its natural position
 * in the DOM tree.
 *
 * See also: ../../wonder-blocks-modal/components/modal-launcher-portal.js
 *
 * TODO(somewhatabstract): Update with a react portal once upgraded to React 16?
 */
var TooltipPortalMounter = function (_React$Component) {
    _inherits(TooltipPortalMounter, _React$Component);

    function TooltipPortalMounter() {
        _classCallCheck(this, TooltipPortalMounter);

        return _possibleConstructorReturn(this, (TooltipPortalMounter.__proto__ || Object.getPrototypeOf(TooltipPortalMounter)).apply(this, arguments));
    }

    _createClass(TooltipPortalMounter, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            // There's a slight chance we have something to mount on our very first
            // render, so let's try it.
            this._maybeCreatePortal();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            // Our content may have changed, so let's update things.
            this._maybeCreatePortal();
        }

        /**
         * When we unmount, we also unmount our children, and the new child of
         * `document.body` we created.
         */

    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this._destroyPortal();
        }
    }, {
        key: "_getPortalParent",
        value: function _getPortalParent() {
            var anchorNode = ReactDOM.findDOMNode(this);
            if (!anchorNode) {
                return null;
            }

            var modalHost = anchorNode && (0, _wonderBlocksModal.maybeGetPortalMountedModalHostElement)(anchorNode);

            var root = modalHost || document.body;
            if (!root) {
                throw new Error("Cannot mount tooltip portal: no document.body nor modal host");
            }
            return root;
        }
    }, {
        key: "_maybeCreatePortal",
        value: function _maybeCreatePortal() {
            // We're not going to create anything if we have no children.
            // As that means we have nothing to render in the portal anyway.
            var children = this.props.children;

            if (!children) {
                this._destroyPortal();
                return;
            }

            var portalParent = this._getPortalParent();
            if (this._destination) {
                // If we already have a portal, we need to see if it is the same
                // one that the current anchor requires or if its different.
                if (portalParent !== this._destination.parentElement) {
                    // If we get here, the portal location changed or we no longer
                    // a portal (because we have no anchor).
                    this._destroyPortal();
                } else {
                    // If we get here, the content of the bubble changed, so let's
                    // remove what we had and render something new. This way, we
                    // reuse the portal we have mounted, rather than take the time
                    // to dismantle it and mount a new one.
                    //
                    // Not certain this is necessary, or if the later render call
                    // handles this, but it seems appropriate and is certainly
                    // clearer to do it here.
                    ReactDOM.unmountComponentAtNode(this._destination);

                    // Render the tooltip into the destination node.
                    this._refreshPortalContent();
                    return;
                }
            }

            if (!portalParent) {
                // We have nowhere to create a portal, so we're done.
                return;
            }

            // Create a new destination node, and add it to the root.
            // The data attribute is to identify the portal when needed.
            var destination = document.createElement("div");
            destination.setAttribute(_constants.TooltipPortalAttributeName, "");
            portalParent.appendChild(destination);

            // Save the destination node, so we can re-use it.
            this._destination = destination;

            // Render the tooltip into the destination node.
            this._refreshPortalContent();
        }
    }, {
        key: "_destroyPortal",
        value: function _destroyPortal() {
            var destination = this._destination;
            if (!destination) {
                return;
            }

            this._destination = null;
            ReactDOM.unmountComponentAtNode(destination);

            if (!destination.parentNode) {
                return;
            }
            destination.parentNode.removeChild(destination);
        }
    }, {
        key: "_refreshPortalContent",
        value: function _refreshPortalContent() {
            var children = this.props.children;

            if (!this._destination || !children) {
                return;
            }

            // Now we can render the portal content.
            // We have to render the subtree like this so that everything works as
            // expected.
            // See https://github.com/tajo/react-portal/blob/master/src/LegacyPortal.js
            ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this._destination);
        }
    }, {
        key: "render",
        value: function render() {
            return this.props.anchor;
        }
    }]);

    return TooltipPortalMounter;
}(React.Component);

exports.default = TooltipPortalMounter;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class is used to track the concept of active state (though technically
 * that could be any boolean state). The tracker has a variety of subscribers
 * that receive notifications of state theft and can steal the state.
 *
 * For the tooltip, this enables us to have a single tooltip active at any one
 * time. The tracker allows tooltip anchors to coordinate which of them is
 * active, and to ensure that if a different one becomes active, all the others
 * know that they aren't.
 *
 * - When notified that the state has been stolen, subscribers can immediately
 * reflect that theft (in the case of a tooltip, they would hide themselves).
 * - The thief does not get notified if they were the one who stole the state
 * since they should already know that they did that (this avoids having to have
 * checks for reentrancy, for example).
 * - When the subscriber that owns the state no longer needs it, it can
 * voluntarily give it up.
 * - If the state is stolen while a subscriber owns the
 * state, that subscriber does not give up the state, as it doesn't have it
 * anymore (it was stolen).
 */
var ActiveTracker = function () {
    function ActiveTracker() {
        _classCallCheck(this, ActiveTracker);

        this._subscribers = [];
    }

    _createClass(ActiveTracker, [{
        key: "_getIndex",
        value: function _getIndex(who) {
            return this._subscribers.findIndex(function (v) {
                return v === who;
            });
        }

        /**
         * Called when a tooltip anchor becomes active so that it can tell all other
         * anchors that they are no longer the active tooltip. Returns true if
         * the there was a steal of active state from another anchor; otherwise, if
         * no other anchor had been active, returns false.
         */

    }, {
        key: "steal",
        value: function steal(who) {
            var wasActive = !!this._active;
            this._active = true;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._subscribers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var anchor = _step.value;

                    if (anchor === who) {
                        // We don't need to notify the thief.
                        continue;
                    }
                    anchor.activeStateStolen();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return wasActive;
        }

        /**
         * Called if a tooltip doesn't want to be active anymore.
         * Should not be called when being told the active spot was stolen by
         * another anchor, only when the anchor is unhovered and unfocused and they
         * were active.
         */

    }, {
        key: "giveup",
        value: function giveup() {
            this._active = false;
        }

        /**
         * Subscribes a tooltip anchor to the tracker so that it can be notified of
         * steals. Returns a method that can be used to unsubscribe the anchor from
         * notifications.
         */

    }, {
        key: "subscribe",
        value: function subscribe(who) {
            var _this = this;

            if (this._getIndex(who) >= 0) {
                throw new Error("Already subscribed.");
            }
            this._subscribers.push(who);

            var unsubscribe = function unsubscribe() {
                var index = _this._getIndex(who);
                _this._subscribers.splice(index, 1);
            };
            return unsubscribe;
        }
    }]);

    return ActiveTracker;
}();

/**
 * This interface should be implemented by types that are interested in the
 * notifications of active state being stolen. Generally, this would also be
 * subscribers that may also steal active state, but not necessarily.
 *
 * Once implemented, the type must call subscribe on a tracker to begin
 * receiving notifications.
 */


exports.default = ActiveTracker;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(5);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _tooltipPortalMounter = __webpack_require__(10);

var _tooltipPortalMounter2 = _interopRequireDefault(_tooltipPortalMounter);

var _activeTracker = __webpack_require__(11);

var _activeTracker2 = _interopRequireDefault(_activeTracker);

var _constants = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * This component turns the given content into an accessible anchor for
 * positioning and displaying tooltips.
 */


var TRACKER = new _activeTracker2.default();

var TooltipAnchor = function (_React$Component) {
    _inherits(TooltipAnchor, _React$Component);

    function TooltipAnchor() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TooltipAnchor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipAnchor.__proto__ || Object.getPrototypeOf(TooltipAnchor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            active: false
        }, _this.activeStateStolen = function () {
            // Something wants the active state.
            // Do we have it? If so, let's remember that.
            // If we are already active, or we're inactive but have a timeoutID,
            // then it was stolen from us.
            _this._stolenFromUs = _this.state.active || !!_this._timeoutID;
            // Let's first tell ourselves we're not focused (otherwise the tooltip
            // will be sticky on the next hover of this anchor and that just looks
            // weird).
            _this._focused = false;
            // Now update our actual state.
            _this._setActiveState(false, true);
        }, _this._handleFocusIn = function () {
            _this._updateActiveState(_this._hovered, true);
        }, _this._handleFocusOut = function () {
            _this._updateActiveState(_this._hovered, false);
        }, _this._handleMouseEnter = function () {
            _this._updateActiveState(true, _this._focused);
        }, _this._handleMouseLeave = function () {
            _this._updateActiveState(false, _this._focused);
        }, _this._handleKeyUp = function (e) {
            // We check the key as that's keyboard layout agnostic and also avoids
            // the minefield of deprecated number type properties like keyCode and
            // which, with the replacement code, which uses a string instead.
            if (e.key === "Escape" && _this.state.active) {
                // Stop the event going any further.
                // For cancellation events, like the Escape key, we generally should
                // air on the side of caution and only allow it to cancel one thing.
                // So, it's polite for us to stop propagation of the event.
                // Otherwise, we end up with UX where one Escape key press
                // unexpectedly cancels multiple things.
                //
                // For example, using Escape to close a tooltip or a dropdown while
                // displaying a modal and having the modal close as well. This would
                // be annoyingly bad UX.
                e.preventDefault();
                e.stopPropagation();
                _this._updateActiveState(false, false);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TooltipAnchor, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var anchorNode = ReactDOM.findDOMNode(this);

            // This should never happen, but we have this check here to make flow
            // happy and ensure that if this does happen, we'll know about it.
            if (anchorNode instanceof Text) {
                throw new Error("TooltipAnchor must be applied to an Element. Text content is not supported.");
            }

            this._unsubscribeFromTracker = TRACKER.subscribe(this);
            this._anchorNode = anchorNode;
            this._updateFocusivity();
            if (anchorNode) {
                /**
                 * TODO(somewhatabstract): Work out how to allow pointer to go over
                 * the tooltip content to keep it active. This likely requires
                 * pointer events but that would break the obscurement checks we do.
                 * So, careful consideration required. See WB-302.
                 */
                anchorNode.addEventListener("focusin", this._handleFocusIn);
                anchorNode.addEventListener("focusout", this._handleFocusOut);
                anchorNode.addEventListener("mouseenter", this._handleMouseEnter);
                anchorNode.addEventListener("mouseleave", this._handleMouseLeave);

                this.props.anchorRef(this._anchorNode);
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            if (prevProps.forceAnchorFocusivity !== this.props.forceAnchorFocusivity || prevProps.children !== this.props.children) {
                this._updateFocusivity();
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this._unsubscribeFromTracker) {
                this._unsubscribeFromTracker();
            }
            this._clearPendingAction();

            var anchorNode = this._anchorNode;
            if (anchorNode) {
                anchorNode.removeEventListener("focusin", this._handleFocusIn);
                anchorNode.removeEventListener("focusout", this._handleFocusOut);
                anchorNode.removeEventListener("mouseenter", this._handleMouseEnter);
                anchorNode.removeEventListener("mouseleave", this._handleMouseLeave);
            }
            if (this.state.active) {
                document.removeEventListener("keyup", this._handleKeyUp);
            }
        }
    }, {
        key: "_updateFocusivity",
        value: function _updateFocusivity() {
            var anchorNode = this._anchorNode;
            if (!anchorNode) {
                return;
            }
            var forceAnchorFocusivity = this.props.forceAnchorFocusivity;

            var currentTabIndex = anchorNode.getAttribute("tabindex");

            if (forceAnchorFocusivity && !currentTabIndex) {
                // Ensure that the anchor point is keyboard focusable so that
                // we can show the tooltip for visually impaired users that don't
                // use pointer devices nor assistive technology like screen readers.
                anchorNode.setAttribute("tabindex", "0");
                this._weSetFocusivity = true;
            } else if (!forceAnchorFocusivity && currentTabIndex) {
                // We may not be forcing it, but we also want to ensure that if we
                // did before, we remove it.
                if (this._weSetFocusivity) {
                    anchorNode.removeAttribute("tabindex");
                    this._weSetFocusivity = false;
                }
            }
        }
    }, {
        key: "_updateActiveState",
        value: function _updateActiveState(hovered, focused) {
            // Update our stored values.
            this._hovered = hovered;
            this._focused = focused;

            this._setActiveState(hovered || focused);
        }
    }, {
        key: "_clearPendingAction",
        value: function _clearPendingAction() {
            if (this._timeoutID) {
                clearTimeout(this._timeoutID);
                this._timeoutID = null;
            }
        }
    }, {
        key: "_setActiveState",
        value: function _setActiveState(active, instant) {
            var _this2 = this;

            if (this._stolenFromUs || active !== this.state.active || !this.state.active && this._timeoutID) {
                // If we are about to lose active state or change it, we need to
                // cancel any pending action to show ourselves.
                // So, if active is stolen from us, we are changing active state,
                // or we are inactive and have a timer, clear the action.
                this._clearPendingAction();
            } else if (active === this.state.active) {
                // Nothing to do if we're already active.
                return;
            }

            // Determine if we are doing things immediately or not.
            instant = instant || active && TRACKER.steal(this);
            if (instant) {
                if (active) {
                    document.addEventListener("keyup", this._handleKeyUp);
                } else {
                    document.removeEventListener("keyup", this._handleKeyUp);
                }
                this.setState({ active: active });
                if (!this._stolenFromUs && !active) {
                    // Only the very last thing going inactive will giveup
                    // the stolen active state.
                    TRACKER.giveup();
                }
                this._stolenFromUs = false;
            } else {
                var delay = active ? _constants.TooltipAppearanceDelay : _constants.TooltipDisappearanceDelay;
                this._timeoutID = setTimeout(function () {
                    _this2._timeoutID = null;
                    _this2._setActiveState(active, true);
                }, delay);
            }
        }
    }, {
        key: "render",
        value: function render() {
            return this.props.children(this.state.active);
        }
    }]);

    return TooltipAnchor;
}(React.Component);

TooltipAnchor.defaultProps = {
    forceAnchorFocusivity: true
};
exports.default = TooltipAnchor;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(5);

var ReactDOM = _interopRequireWildcard(_reactDom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * This is a little helper that we can use to wrap the react-popper reference
 * update methods so that we can convert a regular React ref into a DOM node
 * as react-popper expects, and also ensure we only update react-popper
 * on actual changes, and not just renders of the same thing.
 */


var RefTracker = function RefTracker() {
    var _this = this;

    _classCallCheck(this, RefTracker);

    this.updateRef = function (ref) {
        if (ref) {
            // We only want to update the reference if it is
            // actually changed. Otherwise, we can trigger another render that
            // would then update the reference again and just keep looping.
            var domNode = ReactDOM.findDOMNode(ref);
            if (domNode instanceof HTMLElement && domNode !== _this._lastRef) {
                _this._lastRef = domNode;
                _this._targetFn && _this._targetFn(domNode);
            }
        }
    };

    this.setCallback = function (targetFn) {
        if (_this._targetFn !== targetFn) {
            if (targetFn && typeof targetFn !== "function") {
                throw new Error("targetFn must be a function");
            }

            _this._targetFn = targetFn || null;
            if (_this._lastRef && _this._targetFn) {
                _this._targetFn(_this._lastRef);
            }
        }
    };
};

exports.default = RefTracker;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isObscured;

/**
 * Determine if an element is obscured by other elements.
 *
 * TODO: This is currently duplicated across the tooltip and dropdown packages.
 * Find a shared place to put this and reuse.
 *
 * This uses document.elementFromPoint to see if the given element is being
 * overdrawn by another element. Note that this won't work if the given element
 * has `pointer-events: none`.
 */
function isObscured(element) {
    // TODO(somewhatabstract): We should be smarter in this algorithm and
    // actually look at the intersection of the elements doing the obscuring
    // just as we already do with our scroll parent intersections. That way we
    // can not only check that the entire element is obscured, but think about
    // partial obscurement so we can move the tooltip bubble when it's anchor
    // point is not visible.

    // Before we assume we're visible let's check to see if something else
    // is obscuring us.  Here we make the assumption that if our topleft and
    // bottomright corners are covered by something, we're not visible.
    // There are ways that this can still not work, such as different
    // elements only covering those points and the remainder being visible,
    // or if some covering element has none for pointer-events style, but
    // those edge cases shouldn't bother the main usages for this method.

    // NOTE: If the anchor element has `pointer-events: none`, we're always
    // going to end up hiding, so, you know, probably don't do that.
    // We're not explicitly checking for that CSS since it's a corner-case and
    // would impact perf of the regular cases if we were always checking it.
    // TODO(somewhatabstract): Consider how we might mitigate the pointer-events
    // issue and make this call more robust.
    var anchorRect = element.getBoundingClientRect();
    var style = element.currentStyle || window.getComputedStyle(element);
    var anchorLeft = anchorRect.left + parseFloat(style.marginLeft) + parseFloat(style.paddingLeft) + parseFloat(style.borderLeftWidth);
    var anchorTop = anchorRect.top + parseFloat(style.marginTop) + parseFloat(style.paddingTop) + parseFloat(style.borderTopWidth);
    var topLeftElement = document.elementFromPoint(anchorLeft, anchorTop);
    // The bottom right corner is one less than the bounds, otherwise we
    // can end up getting the parent of the anchor, rather than the anchor
    // itself.
    var anchorRight = anchorRect.right - parseFloat(style.marginRight) - parseFloat(style.paddingRight) - parseFloat(style.borderRightWidth);
    var anchorBottom = anchorRect.bottom - parseFloat(style.marginBottom) - parseFloat(style.paddingBottom) - parseFloat(style.borderBottomWidth);
    var bottomRightElement = document.elementFromPoint(anchorRight, anchorBottom);
    // TODO(somewhatabstract): Need to cater to the case where the viewport is
    // zoomed such that both corners are off screen but the rest isn't as in
    // some browsers, elementFromPoint then doesn't return the element (see
    // WB-300).

    // To cope with us hitting a child of our anchor or a parent due to
    // borders and things, we do some descendancy checks. We're ok with
    // saying that we're visible if we hit a parent because we already
    // checked them for visibility earlier.
    var topLeftVisible = topLeftElement && (element.contains(topLeftElement) || topLeftElement.contains(element));
    var bottomRightVisible = bottomRightElement && (element.contains(bottomRightElement) || bottomRightElement.contains(element));
    return !topLeftVisible && !bottomRightVisible;
}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = require("popper.js");

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _popper = __webpack_require__(15);

var _popper2 = _interopRequireDefault(_popper);

var _wonderBlocksCore = __webpack_require__(1);

var _isObscured = __webpack_require__(14);

var _isObscured2 = _interopRequireDefault(_isObscured);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The function that implements the modifier.
 */
function visibilityModifierFn(data) {
    var anchorElement = data.instance.reference;

    // First, we see how the element intersects with its scroll parents.
    // If it doesn't, then we should hide it.
    // Otherwise, we check to see if anything else obscures the component (like
    // a fixed or absolute positioned element).

    var _getElementIntersecti = (0, _wonderBlocksCore.getElementIntersection)(anchorElement),
        horizontal = _getElementIntersecti.horizontal,
        vertical = _getElementIntersecti.vertical;

    var hide = horizontal !== "within" || vertical !== "within" || (0, _isObscured2.default)(anchorElement);

    // If we're hidden, we mimic what the built-in hide method does,
    // and set the hide flag and the OOB attribute with appropriate
    // short-circuiting.
    // https://github.com/FezVrasta/popper.js/blob/08c5d6010346bf9df06e9f81a54fa6c2c51e3639/packages/popper/src/modifiers/hide.js#L29-L42
    if (hide) {
        if (data.hide) {
            return data;
        }
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (!data.hide) {
            return data;
        }
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }

    // Always have to return the data object to ensure the modifier chain
    // in popper.js is unbroken.
    return data;
}

/**
 * Default configuration that sets things up how usually want them.
 * Usage:
 * ```js
 *     import visibilityModifier from "visibility-modifier.js";
 *     const modifiers = [
 *         wbvisibility: visibilityModifier,
 *     ];
 * ```
 *
 * Where `wbvisibility` is a unique name to give the modifier entry,
 * and `modifiers` is the popper.js or react-popper modifiers array.
 */

/**
 * A modifier for use with popper.js or react-popper.
 *
 * TODO: This is currently duplicated across the tooltip and dropdown packages.
 * Find a shared place to put this and reuse.
 *
 * This looks at the scroll parents of the reference element to determine
 * overall visibility.
 *
 * See https://popper.js.org/popper-documentation.html#modifiers for more
 * details on popper.js modifiers.
 */
exports.default = {
    enabled: true,
    // We want this to run after the "hide" modifier, by default.
    order: _popper2.default.Defaults.modifiers["hide"].order + 1,
    fn: visibilityModifierFn
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _aphrodite = __webpack_require__(4);

var _wonderBlocksColor = __webpack_require__(6);

var _wonderBlocksColor2 = _interopRequireDefault(_wonderBlocksColor);

var _wonderBlocksCore = __webpack_require__(1);

var _wonderBlocksSpacing = __webpack_require__(3);

var _wonderBlocksSpacing2 = _interopRequireDefault(_wonderBlocksSpacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO(somewhatabstract): Replace this really basic unique ID work with
// something SSR-friendly and more robust.
var tempIdCounter = 0;

var TooltipTail = function (_React$Component) {
    _inherits(TooltipTail, _React$Component);

    function TooltipTail() {
        _classCallCheck(this, TooltipTail);

        return _possibleConstructorReturn(this, (TooltipTail.__proto__ || Object.getPrototypeOf(TooltipTail)).apply(this, arguments));
    }

    _createClass(TooltipTail, [{
        key: "_calculateDimensionsFromPlacement",
        value: function _calculateDimensionsFromPlacement() {
            var placement = this.props.placement;

            // The trimline, which we draw to make the tail flush to the bubble,
            // has a thickness of 1. Since the line is drawn centered to the
            // coordinates, we use an offset of 0.5 so that it properly covers what
            // we want it to.

            var trimlineOffset = 0.5;

            // Calculate the three points of the arrow. Depending on the tail's
            // direction (i.e., the tooltip's "side"), we choose different points,
            // and set our SVG's bounds differently.
            //
            // Note that when the tail points to the left or right, the width/height
            // are inverted.
            switch (placement) {
                case "top":
                    return {
                        trimlinePoints: ["0,-" + trimlineOffset, ARROW_WIDTH + ",-" + trimlineOffset],
                        points: ["0,0", ARROW_WIDTH / 2 + "," + ARROW_HEIGHT, ARROW_WIDTH + ",0"],
                        height: ARROW_HEIGHT,
                        width: ARROW_WIDTH
                    };

                case "right":
                    return {
                        trimlinePoints: [ARROW_HEIGHT + trimlineOffset + ",0", ARROW_HEIGHT + trimlineOffset + "," + ARROW_WIDTH],
                        points: [ARROW_HEIGHT + ",0", "0," + ARROW_WIDTH / 2, ARROW_HEIGHT + "," + ARROW_WIDTH],
                        width: ARROW_HEIGHT,
                        height: ARROW_WIDTH
                    };

                case "bottom":
                    return {
                        trimlinePoints: ["0, " + (ARROW_HEIGHT + trimlineOffset), ARROW_WIDTH + "," + (ARROW_HEIGHT + trimlineOffset)],
                        points: ["0, " + ARROW_HEIGHT, ARROW_WIDTH / 2 + ",0", ARROW_WIDTH + "," + ARROW_HEIGHT],
                        width: ARROW_WIDTH,
                        height: ARROW_HEIGHT
                    };

                case "left":
                    return {
                        trimlinePoints: ["-" + trimlineOffset + ",0", "-" + trimlineOffset + "," + ARROW_WIDTH],
                        points: ["0,0", ARROW_HEIGHT + "," + ARROW_WIDTH / 2, "0," + ARROW_WIDTH],
                        width: ARROW_HEIGHT,
                        height: ARROW_WIDTH
                    };

                default:
                    throw new Error("Unknown placement: " + placement);
            }
        }
    }, {
        key: "_getFilterPositioning",
        value: function _getFilterPositioning() {
            var placement = this.props.placement;

            switch (placement) {
                case "top":
                    return {
                        y: "-50%",
                        x: "-50%",
                        offsetShadowX: 0
                    };

                case "bottom":
                    // No shadow on the arrow as it falls "under" the bubble.
                    return null;

                case "left":
                    return {
                        y: "-50%",
                        x: "0%",
                        offsetShadowX: 1
                    };

                case "right":
                    return {
                        y: "-50%",
                        x: "-100%",
                        offsetShadowX: -1
                    };

                default:
                    throw new Error("Unknown placement: " + placement);
            }
        }

        /**
         * Create an SVG filter that applies a blur to an element.
         * We'll apply it to a dark shape outlining the tooltip, which
         * will produce the overall effect of a drop-shadow.
         *
         * Also, scope its ID by side, so that tooltips with other
         * "side" values don't end up using the wrong filter from
         * elsewhere in the document. (The `height` value depends on
         * which way the arrow is turned!)
         */

    }, {
        key: "_maybeRenderDropshadow",
        value: function _maybeRenderDropshadow(points) {
            var position = this._getFilterPositioning();
            if (!position) {
                return null;
            }
            var placement = this.props.placement;
            var y = position.y,
                x = position.x,
                offsetShadowX = position.offsetShadowX;

            var dropShadowFilterId = "tooltip-dropshadow-" + placement + "-" + tempIdCounter++;
            return [React.createElement(
                "filter",
                {
                    key: "filter",
                    id: dropShadowFilterId
                    // Height and width tell the filter how big of a canvas to
                    // draw based on its parent size. i.e. 2 times bigger.
                    // This is so that the diffuse gaussian blur has space to
                    // bleed into.
                    , width: "200%",
                    height: "200%"
                    // The x and y values tell the filter where, relative to its
                    // parent, it should begin showing its canvas. Without these
                    // the filter would clip at 0,0, which would look really
                    // strange.
                    , x: x,
                    y: y
                },
                React.createElement("feGaussianBlur", {
                    "in": "SourceAlpha",
                    stdDeviation: _wonderBlocksSpacing2.default.xxSmall / 2
                }),
                React.createElement(
                    "feComponentTransfer",
                    null,
                    React.createElement("feFuncA", { type: "linear", slope: "0.3" })
                )
            ),
            /**
             * Draw the tooltip arrow and apply the blur filter we created
             * above, to produce a drop shadow effect.
             * We move it down a bit with a translation, so that it is what
             * we want.
             *
             * We offset the shadow on the X-axis because for left/right
             * tails, we move the tail 1px toward the bubble. If we didn't
             * offset the shadow, it would crash the bubble outline.
             *
             * See styles below for why we offset the arrow.
             */
            React.createElement(
                "g",
                { key: "dropshadow", transform: "translate(" + offsetShadowX + ",5.5)" },
                React.createElement("polyline", {
                    fill: _wonderBlocksColor2.default.offBlack16,
                    points: points.join(" "),
                    stroke: _wonderBlocksColor2.default.offBlack32,
                    filter: "url(#" + dropShadowFilterId + ")"
                })
            )];
        }
    }, {
        key: "_minDistanceFromCorners",
        value: function _minDistanceFromCorners(placement) {
            var minDistanceFromCornersForTopBottom = _wonderBlocksSpacing2.default.medium;
            var minDistanceFromCornersForLeftRight = 7;

            switch (placement) {
                case "top":
                case "bottom":
                    return minDistanceFromCornersForTopBottom;

                case "left":
                case "right":
                    return minDistanceFromCornersForLeftRight;

                default:
                    throw new Error("Unknown placement: " + placement);
            }
        }
    }, {
        key: "_getFullTailWidth",
        value: function _getFullTailWidth() {
            return ARROW_WIDTH + 2 * MIN_DISTANCE_FROM_CORNERS;
        }
    }, {
        key: "_getFullTailHeight",
        value: function _getFullTailHeight() {
            return ARROW_HEIGHT + DISTANCE_FROM_ANCHOR;
        }
    }, {
        key: "_getContainerStyle",
        value: function _getContainerStyle() {
            var placement = this.props.placement;
            /**
             * Ensure the container is sized properly for us to be placed correctly
             * by the Popper.js code.
             *
             * Here we offset the arrow 1px toward the bubble. This ensures the arrow
             * outline meets the bubble outline and allows the arrow to erase the bubble
             * outline between the ends of the arrow outline. We do this so that the
             * arrow outline and bubble outline create a single, seamless outline of
             * the callout.
             *
             * NOTE: The widths and heights refer to the downward-pointing tail
             * (i.e. placement="top"). When the tail points to the left or right
             * instead, the width/height are inverted.
             */

            var fullTailWidth = this._getFullTailWidth();
            var fullTailHeight = this._getFullTailHeight();

            switch (placement) {
                case "top":
                    return {
                        top: -1,
                        width: fullTailWidth,
                        height: fullTailHeight
                    };

                case "right":
                    return {
                        left: 1,
                        width: fullTailHeight,
                        height: fullTailWidth
                    };

                case "bottom":
                    return {
                        top: 1,
                        width: fullTailWidth,
                        height: fullTailHeight
                    };

                case "left":
                    return {
                        left: -1,
                        width: fullTailHeight,
                        height: fullTailWidth
                    };

                default:
                    throw new Error("Unknown placement: " + placement);
            }
        }
    }, {
        key: "_getArrowStyle",
        value: function _getArrowStyle() {
            var placement = this.props.placement;

            switch (placement) {
                case "top":
                    return {
                        marginLeft: MIN_DISTANCE_FROM_CORNERS,
                        marginRight: MIN_DISTANCE_FROM_CORNERS,
                        paddingBottom: DISTANCE_FROM_ANCHOR
                    };

                case "right":
                    return {
                        marginTop: MIN_DISTANCE_FROM_CORNERS,
                        marginBottom: MIN_DISTANCE_FROM_CORNERS,
                        paddingLeft: DISTANCE_FROM_ANCHOR
                    };

                case "bottom":
                    return {
                        marginLeft: MIN_DISTANCE_FROM_CORNERS,
                        marginRight: MIN_DISTANCE_FROM_CORNERS,
                        paddingTop: DISTANCE_FROM_ANCHOR
                    };

                case "left":
                    return {
                        marginTop: MIN_DISTANCE_FROM_CORNERS,
                        marginBottom: MIN_DISTANCE_FROM_CORNERS,
                        paddingRight: DISTANCE_FROM_ANCHOR
                    };

                default:
                    throw new Error("Unknown placement: " + placement);
            }
        }
    }, {
        key: "_renderArrow",
        value: function _renderArrow() {
            var _calculateDimensionsF = this._calculateDimensionsFromPlacement(),
                trimlinePoints = _calculateDimensionsF.trimlinePoints,
                points = _calculateDimensionsF.points,
                height = _calculateDimensionsF.height,
                width = _calculateDimensionsF.width;

            return React.createElement(
                "svg",
                {
                    className: (0, _aphrodite.css)(styles.arrow),
                    style: this._getArrowStyle(),
                    width: width,
                    height: height
                },
                this._maybeRenderDropshadow(points),
                React.createElement("polyline", {
                    fill: _wonderBlocksColor2.default.white,
                    stroke: _wonderBlocksColor2.default.white,
                    points: points.join(" ")
                }),
                React.createElement("polyline", {
                    // Redraw the stroke on top of the background color,
                    // so that the ends aren't extra dark where they meet
                    // the border of the tooltip.
                    fill: _wonderBlocksColor2.default.white,
                    points: points.join(" "),
                    stroke: _wonderBlocksColor2.default.offBlack16
                }),
                React.createElement("polyline", {
                    stroke: _wonderBlocksColor2.default.white,
                    points: trimlinePoints.join(" ")
                })
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                offset = _props.offset,
                placement = _props.placement,
                updateRef = _props.updateRef;

            return React.createElement(
                _wonderBlocksCore.View,
                {
                    style: [styles.tailContainer, offset, this._getContainerStyle()],
                    "data-placement": placement,
                    ref: updateRef
                },
                this._renderArrow()
            );
        }
    }]);

    return TooltipTail;
}(React.Component);

/**
 * Some constants to make style generation easier to understand.
 * NOTE: The widths and heights refer to the downward-pointing tail
 * (i.e. placement="top"). When the tail points to the left or right instead,
 * the width/height are inverted.
 */


exports.default = TooltipTail;
var DISTANCE_FROM_ANCHOR = _wonderBlocksSpacing2.default.xSmall;

var MIN_DISTANCE_FROM_CORNERS = _wonderBlocksSpacing2.default.xSmall;

var ARROW_WIDTH = _wonderBlocksSpacing2.default.large;
var ARROW_HEIGHT = _wonderBlocksSpacing2.default.small;

var styles = _aphrodite.StyleSheet.create({
    /**
     * Container
     */
    tailContainer: {
        position: "relative",
        pointerEvents: "none"
    },

    /**
     * Arrow
     */
    arrow: {
        // Ensure the dropshadow bleeds outside our bounds.
        overflow: "visible"
    }
});

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-typography");

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-layout");

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("react-popper");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("@khanacademy/wonder-blocks-modal");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _wonderBlocksCore = __webpack_require__(1);

var _tooltipPortalMounter = __webpack_require__(10);

var _tooltipPortalMounter2 = _interopRequireDefault(_tooltipPortalMounter);

var _tooltipAnchor = __webpack_require__(12);

var _tooltipAnchor2 = _interopRequireDefault(_tooltipAnchor);

var _tooltipBubble = __webpack_require__(7);

var _tooltipBubble2 = _interopRequireDefault(_tooltipBubble);

var _tooltipContent = __webpack_require__(2);

var _tooltipContent2 = _interopRequireDefault(_tooltipContent);

var _tooltipPopper = __webpack_require__(8);

var _tooltipPopper2 = _interopRequireDefault(_tooltipPopper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * The Tooltip component provides the means to anchor some additional
 * information to some content. The additional information is shown in a
 * callout that hovers above the page content. This additional information is
 * invoked by hovering over the anchored content, or focusing all or part of the
 * anchored content.
 *
 * This component is structured as follows:
 *
 * Tooltip (this component)
 * - TooltipAnchor (provides hover/focus behaviors on anchored content)
 *   - TooltipPortalMounter (creates portal into which the callout is rendered)
 * --------------------------- [PORTAL BOUNDARY] ------------------------------
 * - TooltipPopper (provides positioning for the callout using react-popper)
 *   - TooltipBubble (renders the callout borders, background and shadow)
 *     - TooltipContent (renders the callout content; the actual information)
 *     - TooltipTail (renders the callout tail and shadow that points from the
 *                     callout to the anchor content)
 */


var Tooltip = function (_React$Component) {
    _inherits(Tooltip, _React$Component);

    function Tooltip() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Tooltip);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = { anchorElement: null }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Tooltip, [{
        key: "_updateAnchorElement",
        value: function _updateAnchorElement(ref) {
            if (ref && ref !== this.state.anchorElement) {
                this.setState({ anchorElement: ref });
            }
        }
    }, {
        key: "_renderAnchorElement",
        value: function _renderAnchorElement(ids) {
            // We need to make sure we can anchor on our content.
            // If the content is just a string, we wrap it in a Text element
            // so as not to affect styling or layout but still have an element
            // to anchor to.
            var children = this.props.children;

            var anchorableChildren = typeof children === "string" ? React.createElement(
                _wonderBlocksCore.Text,
                null,
                children
            ) : children;

            if (ids) {
                return React.cloneElement(anchorableChildren, {
                    "aria-describedby": ids.get(Tooltip.ariaContentId)
                });
            } else {
                return anchorableChildren;
            }
        }
    }, {
        key: "_renderBubbleContent",
        value: function _renderBubbleContent() {
            var _props = this.props,
                title = _props.title,
                content = _props.content;

            if (typeof content === "string") {
                return React.createElement(
                    _tooltipContent2.default,
                    { title: title },
                    content
                );
            } else if (title) {
                return React.cloneElement(content, { title: title });
            } else {
                return content;
            }
        }
    }, {
        key: "_renderPopper",
        value: function _renderPopper(active, ids) {
            var _this2 = this;

            if (!active) {
                return null;
            }

            var id = this.props.id;

            var bubbleId = ids ? ids.get(Tooltip.ariaContentId) : id;
            if (!bubbleId) {
                throw new Error("Did not get an identifier factory nor a id prop");
            }

            var placement = this.props.placement;

            return React.createElement(
                _tooltipPopper2.default,
                {
                    anchorElement: this.state.anchorElement,
                    placement: placement
                },
                function (props) {
                    return React.createElement(
                        _tooltipBubble2.default,
                        {
                            id: bubbleId,
                            style: props.style,
                            tailOffset: props.tailOffset,
                            outOfBoundaries: props.outOfBoundaries,
                            placement: props.placement,
                            updateTailRef: props.updateTailRef,
                            updateBubbleRef: props.updateBubbleRef
                        },
                        _this2._renderBubbleContent()
                    );
                }
            );
        }
    }, {
        key: "_renderTooltipAnchor",
        value: function _renderTooltipAnchor(ids) {
            var _this3 = this;

            var forceAnchorFocusivity = this.props.forceAnchorFocusivity;

            return React.createElement(
                _tooltipAnchor2.default,
                {
                    forceAnchorFocusivity: forceAnchorFocusivity,
                    anchorRef: function anchorRef(r) {
                        return _this3._updateAnchorElement(r);
                    }
                },
                function (active) {
                    return React.createElement(
                        _tooltipPortalMounter2.default,
                        {
                            anchor: _this3._renderAnchorElement(ids)
                        },
                        _this3._renderPopper(active, ids)
                    );
                }
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var id = this.props.id;

            if (id) {
                // Let's bypass the extra weight of an id provider since we don't
                // need it.
                return this._renderTooltipAnchor();
            } else {
                return React.createElement(
                    _wonderBlocksCore.UniqueIDProvider,
                    { scope: "tooltip", mockOnFirstRender: true },
                    function (ids) {
                        return _this4._renderTooltipAnchor(ids);
                    }
                );
            }
        }
    }]);

    return Tooltip;
}(React.Component);

Tooltip.ariaContentId = "aria-content";
Tooltip.defaultProps = {
    forceAnchorFocusivity: true,
    placement: "top"
};
exports.default = Tooltip;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContent = exports.default = undefined;

var _tooltip = __webpack_require__(22);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _tooltipContent = __webpack_require__(2);

var _tooltipContent2 = _interopRequireDefault(_tooltipContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _tooltip2.default;
exports.TooltipContent = _tooltipContent2.default;

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@khanacademy/wonder-blocks-tooltip/index.js
// module id = 1058
// module chunks = 0